import TextableProperty from '../TextableProperty';

export default class TextSettingsProperty extends TextableProperty {

    constructor(opts = {}) {
        super();

        // this.borderWidth.value = 0;
        this.fontSize.value = 14 * 3;

        for (var p in opts) {
            this[p].value = opts[p];
        }

        this.defineAllProperties();
    }
    
    toString() {
        return "设置";
    }
}
